export const ratingType = {
  SURVEY: 'SURVEY',
  COURSE: 'COURSE',
  HOME: 'HOME'
};
